package de.ohhhmhhh.frontend.admin.ui.screens.user.activity

import de.ohhhmhhh.backend.models.model.user.ActivityEntity

data class UserActivityState(
    val id: String? = null,
    val items: List<ActivityEntity> = emptyList()
)
